import CryptoJS from 'crypto-js';

const KEY = 'JARVIS_3_0_XAU_USD_SECURE_2026';

export const encrypt = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), KEY).toString();
};

export const decrypt = (encrypted) => {
  const bytes = CryptoJS.AES.decrypt(encrypted, KEY);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const secureGet = (storageKey, fallback = []) => {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return fallback;
    // Try decrypt first; if fails, try plain JSON (migration safety)
    try {
      return decrypt(raw);
    } catch {
      return JSON.parse(raw);
    }
  } catch {
    return fallback;
  }
};

export const secureSet = (storageKey, data) => {
  try {
    localStorage.setItem(storageKey, encrypt(data));
  } catch (e) {
    // LocalStorage full — warn but don't crash
    console.warn('JARVIS storage warning:', e.message);
  }
};
